export default __webpack_public_path__ + "images/composite_yoko_rgb_color.svg";